module.exports = __webpack_public_path__ + "img/schedule-service-bar-black.b4594f79.png";